module.exports = __webpack_public_path__ + "static/media/bannerVideo_1.92dedfe9.mp4";